import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui'
import { useToast } from '@/hooks'
import { useAnalysisMutations } from '@/modules/analysis'
import { useProject } from '@/modules/projects'
import { useDialogActions, useDialogIsOpen } from '@/stores'

const dialogId = 'delete-analysis'

export const DeleteAnalysisDialog = () => {
  const { successToast, errorToast } = useToast()
  const { deleteAnalysis } = useAnalysisMutations()
  const { closeDialog } = useDialogActions()
  const projectSlug = useProject()
  const open = useDialogIsOpen(dialogId)

  const handleSubmit = async () => {
    deleteAnalysis(projectSlug?.slug as string)
      .then(() => successToast(`Report deleted successfully`))
      .catch((error) => errorToast(`Failed to delete report`, error))
    closeDialog(true)
  }

  return (
    <Dialog open={open} onOpenChange={(open) => !open && closeDialog()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Delete Report?</DialogTitle>
          <DialogDescription>
            This will permanently delete the report.This action cannot be
            undone.
          </DialogDescription>
        </DialogHeader>
        <div className="flex justify-end gap-2 pt-4">
          <Button theme="outline" onClick={() => closeDialog()}>
            Cancel
          </Button>
          <Button onClick={handleSubmit} theme="danger">
            Delete Report
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}

DeleteAnalysisDialog.id = dialogId
